import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// The buy flow is no longer a route — `InvestDrawer` opens over the host
// screen from list + detail. The investment calculator stays as a route
// (it's a standalone discovery page, not a transaction surface).
export const investRoutes: RouteRecordRaw[] = [
  {
    path: routes.INVESTMENT_CALCULATOR,
    name: 'INVESTMENT_CALCULATOR',
    component: () => import('./InvestmentCalculatorPage.vue'),
    meta: { requiresAuth: true },
  },
]
